import posthog from 'posthog-js'
import { env } from '@/config/env'
import { resolveAnalyticsEnvironment } from './environment'

const MISSING_KEY_WARNING =
  'VITE_POSTHOG_KEY is missing — PostHog disabled (no capture until configured).'

let initialized = false

export function isPostHogEnabled(): boolean {
  return initialized
}

/** Initialize when key present; otherwise no-op (safe for local dev). */
export function initPostHog(): boolean {
  const key = env.VITE_POSTHOG_KEY
  if (!key) {
    if (import.meta.env.DEV) {
      console.warn(MISSING_KEY_WARNING)
    }
    return false
  }

  posthog.init(key, {
    api_host: env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: false,
    capture_pageleave: true,
  })
  posthog.register({ environment: resolveAnalyticsEnvironment() })
  initialized = true
  return true
}

export function captureAnalyticsEvent(
  event: string,
  properties?: Record<string, string | number | boolean | null>,
): void {
  if (!initialized) return
  posthog.capture(event, properties)
}

/** Identify Sensemaker user after session load — platform user id only (rule 56). */
export function identifySmUser(sensemakerUserId: string): void {
  if (!initialized || !sensemakerUserId) return
  posthog.identify(sensemakerUserId)
}
